<template>
	<div class="d-flex align-items-center social-share">
			<ShareNetwork
				network="facebook"
				:url="url"
				:title="title"
				description="description"
			>
				<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-facebook"></use></svg>
			</ShareNetwork>
			<ShareNetwork
				network="twitter"
				:url="url"
				:title="title"
				description="description"
			>
				<img src="/images/twitter.svg" alt="">
<!--				<svg class="ticon"><use xlink:href="/images/twitter.svg"></use></svg>-->
			</ShareNetwork>
	</div>
</template>
<script>
import VueSocialSharing from 'vue-social-sharing'

export default {
	components: {
		VueSocialSharing
	},
	props: {
		url: {
			type: String,
			default: () => {
				return location.protocol + '//' + location.host + location.pathname
			}
		},
		title: {
			type: String
		}
	}
}
</script>
